import { useState } from 'react';

export function useJoinWorkspaceWithCodeDialog() {
  const [isJoinWorkspaceWithCodeDialogOpen, setIsJoinWorkspaceWithCodeOpen] =
    useState(false);

  const openJoinWorkspaceWithCodeDialog = () => {
    setIsJoinWorkspaceWithCodeOpen(true);
  };

  const closeJoinWorkspaceWithCodeDialog = () => {
    setIsJoinWorkspaceWithCodeOpen(false);
  };

  return {
    isJoinWorkspaceWithCodeDialogOpen,
    openJoinWorkspaceWithCodeDialog,
    closeJoinWorkspaceWithCodeDialog,
  };
}
